import EsqueciSenhaPage from "./EsqueciSenhaPage";

const EsqueciSenhaPageConnected = () => {
  return <EsqueciSenhaPage />;
};

export default EsqueciSenhaPageConnected;
